export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** Slugs that cannot be used by games or categories because the site reserves the path. */
export const RESERVED_CATALOG_SLUGS: readonly string[] = ["originals"];

export function slugify(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 120);
}

export function isValidSlug(value: string): boolean {
  return SLUG_PATTERN.test(value) && value.length <= 120;
}
